export enum LoadingEnum{
    ACCOMODATION = "ACCOMODATION",
    ROUTE ="ROUTE" 
}